import { Indexable } from 'src/app/core/models/indexable';
import { TablePattern } from 'src/app/models/table-patterns';
// tslint:disable: variable-name


export type DocumentIdentifier =
  'COVID_CERTIFICATE' |
  'MATCH_MEDICAL_AVALIATION' |
  'BID' |
  'REFEREES_LINEUP' |
  'SCORESHEET' |
  'address_certificate' |
  'document_picture' |
  'driver_licence' |
  'election_document' |
  'federal_document' |
  'regional_document' |
  'school_certificate' |
  'medical_certificate' |
  'merchandise_document' |
  'custom';

// export const DOCUMENT_IDENTIFIER: Indexable<DocumentIdentifier, string> = {
//   COVID_CERTIFICATE: 'Certificado COVID',
//   MATCH_MEDICAL_AVALIATION: 'Avaliação Médica',
//   BID: 'BID',
//   REFEREES_LINEUP: 'Escala de arbitragem',
//   SCORESHEET: 'Súmula',
//   address_certificate: 'Comprovante',
//   document_picture: 'document_picture',
//   driver_licence: 'driver_licence',
//   election_document: 'election_document',
//   federal_document: 'federal_document',
//   regional_document: 'regional_document',
//   school_certificate: 'school_certificate'
// }
export class DocumentTypes extends TablePattern {
  name: string;
  expires: boolean;
  identifier: DocumentIdentifier;
  entities: {
    athletes?: boolean;
    clubs?: boolean;
    contributors?: boolean;
    leagues?: boolean;
    referees?: boolean;
    schools?: boolean;
    teachers?: boolean;
    users?: boolean;
    championships?: boolean
  };

}

export interface DocumentSearchParams {
  identifier?: DocumentIdentifier,
  startAt?: moment.Moment;
  endAt?: moment.Moment;
  parent_id: number;
}

export interface DocumentInfo {
  type: string,
  name: string,
  sizeBytes: number,
  size: string,
  ext: string
}

export class Document extends TablePattern {
  uid?: string;
  document_type_id: number;
  parent_id: number;
  expires?: Date;
  expired?: boolean;
  path?: string;
  file_name?: string;
  size?: number;
  mime_type?: string;
  document_type_name?: string;
  validated?: boolean;
  validation_id?: number;
  validation_expired?: string;
  title?: string;
  description?: string;

  document_type?: DocumentTypes;
  constructor(o: Partial<Document>) {
    super(o);
  }
}
